import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import InvoiceGenerator from './components/demounit';
import InvoiceList from './components/InvoiceList';


const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<InvoiceGenerator />} />                   
        <Route path="/list" element={<InvoiceList />} />     
      </Routes>
    </BrowserRouter>
  );
};

export default App;